import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Every plate of one scope, metadata only.
//
// The same getEmailTemplates resolver as getEmailTemplatesList.js, but with a
// deliberately narrow field selection: the editor's plate switcher and the
// clone modal's "plates to copy" list need to know which languages have a
// plate, whether each is flagged needsReview, and its subject - and nothing
// else. Reusing getEmailTemplatesList here would pull four complete templates,
// htmlContent and all (4-45 nested tables each, up to ~14KB apiece), to render
// four 20px squares.
const GET_EMAIL_SCOPE_PLATES = gql`
query getEmailScopePlates($scope: String, $appName: String) {
  getEmailTemplates(scope: $scope, appName: $appName) {
    isAuth
    total
    error
    templates {
      templateId
      language
      subject
      needsReview
      isActive
      updatedAt
    }
  }
}
`;

const getEmailScopePlates = async (variables) => {
  try {
    const result = await client.query({
      query: GET_EMAIL_SCOPE_PLATES,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getEmailTemplates: templatesData } } = result;

    if (templatesData) {
      return templatesData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getEmailScopePlates = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getEmailScopePlates Error: ${error}`);
    return null;
  }
};

export default getEmailScopePlates;
